import { Typography, Divider as DividerMU, Chip } from '@material-ui/core'
import CardMU from '@material-ui/core/Card'
import { styled as styledMUI } from '@material-ui/styles'
import UBox from 'src/components/ui/Ubox'

export const Card = styledMUI(CardMU)(() => ({
  padding: '8px',
  boxShadow: 'none',
  display: 'flex',
  justifyContent: 'space-between'
}))

export const Content = styledMUI(UBox)(() => ({
  // padding: '0px',
  boxShadow: 'none'
}))

export const Divider = styledMUI(DividerMU)(() => ({
  margin: '6px 0 6px '
}))

export const Tag = styledMUI(Chip)(() => ({
  margin: '2px'
}))

export const MainContent = styledMUI(UBox)(() => ({
  // padding: '0px',
  boxShadow: 'none'
}))

export const Title = styledMUI(UBox)(() => ({
  // textTransform: 'uppercase',
  marginBottom: '8px',
  minHeight: '35px',
  display: 'flex',
  alignItems: 'center',
  '& p': {
    lineHeight: '0.9rem'
  }
}))

export const Label = styledMUI(Typography)({
  color: '#666',
  fontWeight: 500,
  fontSize: '0.75rem'
})

export const Type = styledMUI(Typography)({
  fontWeight: 500,
  fontSize: '0.85rem'
})
